// extracted by mini-css-extract-plugin
export var actionText = "_jv-4";
export var container = "_jv-0";
export var leftSection = "_jv-1";
export var rightSection = "_jv-2";
export var settingsButton = "_jv-6";
export var settingsIcon = "_jv-7";
export var shortcut = "_jv-5";
export var shortcutGroup = "_jv-3";